module.exports = __webpack_public_path__ + "media/images/email/facebook2x (copy)-634e6e4d877a10188b859618c30e4afc.png";